import "core-js/modules/es6.regexp.split";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions, mapMutations } from 'vuex';
import pickBy from 'lodash/pickBy';
import isNil from 'lodash/isNil';
import defer from 'lodash/defer';
import shallowEqualObjects from 'shallow-equal/objects';
import registerStoreModule from '~/helpers/store-helper';
import pageActions from '~/store/modules/pageActions';
import category from '~/store/modules/category';
import { extractCategoryHash, extractCategoryFilterByFromQuery, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractCategoryQueryFromFilterBy, extractSelectedFilters } from '~/helpers/extract-helper';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import CategorySeo from '~/components/functional/Seo/CategorySeo.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import CategoryTcVars from '~/components/functional/TcVars/CategoryTcVars.vue';
import CategoryJsonld from '~/components/functional/JsonLD/CategoryJsonld.vue';
import CategoryCatalog from '~/components/organisms/Category/CategoryCatalog.vue';
import CategoryInformationalContent from '~/components/organisms/Category/CategoryInformationalContent.vue';
import CategoryLoading from '~/components/templates/Category/CategoryLoading.vue';
import CategoryTemplate from '~/components/templates/Category/CategoryTemplate.vue';
import Empty from '~/components/specific/Blocks/Empty.vue';
import CommercialRibbon from '~/components/atoms/Global/CommercialRibbon.vue';
export default {
  validate(_ref) {
    let {
      params: {
        alias
      }
    } = _ref;
    return alias && extractCategoryHash(alias);
  },

  components: {
    MdmBreadcrumb,
    CategorySeo,
    CategoryTcVars,
    CategoryJsonld,
    CategoryCatalog,
    CategoryInformationalContent,
    CategoryLoading,
    CategoryTemplate,
    Empty,
    CommercialRibbon,
    RatingJsonLd
  },
  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=86400, public'
  }),

  fetch(_ref2) {
    return _asyncToGenerator(function* () {
      let {
        params: {
          alias
        },
        query,
        store,
        error
      } = _ref2;
      registerStoreModule(store, 'category/', category);
      registerStoreModule(store, 'pageActions/', pageActions);

      if (process.server) {
        store.commit('pageActions/SET_DEFAULT_FILTERBY', extractCategoryFilterByFromQuery(query));
        store.commit('pageActions/SET_DEFAULT_SORTBY', extractCategorySortByFromQuery(query));
        store.commit('pageActions/SET_DEFAULT_ORDERBY', extractCategoryOrderByFromQuery(query));
        store.commit('pageActions/SET_PREVIOUS_PAGE', extractCategoryPreviousPageFromQuery(query));
        store.commit('pageActions/SET_NEXT_PAGE', extractCategoryNextPageFromQuery(query));

        try {
          yield store.dispatch('category/fetchContent', {
            alias,
            query
          });
        } catch (err) {
          error({
            statusCode: 404,
            message: 'Not Found'
          });
        }
      }
    })();
  },

  asyncData() {
    return {
      serverFetch: process.server
    };
  },

  data() {
    return {
      loadingProducts: true,
      loadingNextPage: false,
      loadingPreviousPage: false,
      unwatchCategoryQuery: null,
      unwatchNextPage: null,
      unwatchPreviousPage: null
    };
  },

  computed: _objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    description: 'category/description',
    products: 'category/products',
    productsCount: 'category/productsCount',
    filterBy: 'pageActions/filterBy',
    orderBy: 'pageActions/orderBy',
    sortBy: 'pageActions/sortBy',
    previousPage: 'pageActions/previousPage',
    nextPage: 'pageActions/nextPage'
  }), {
    categoryQuery() {
      return _objectSpread({}, extractCategoryQueryFromFilterBy(this.filterBy), {
        sort: this.sortBy,
        order: this.orderBy
      });
    },

    selectedFilters() {
      return extractSelectedFilters(this.filterBy, this.description.filters);
    },

    currentPath() {
      return "".concat(this.baseURL).concat(this.buildCategoryUrl(this.locale, this.description.slug, this.description.hash));
    },

    breadcrumb() {
      const breadcrumb = this.description.breadcrumb || [];
      return breadcrumb.map(entry => ({
        label: entry.title,
        url: entry.slug ? "".concat(this.baseURL).concat(this.buildCategoryUrl(this.locale, entry.slug, entry.hash)) : "/".concat(this.locale.market, "/").concat(this.locale.language)
      }));
    },

    pageTitle() {
      return this.description.seo.meta_title || this.description.name || '';
    },

    speedcurveConfig() {
      const luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "category";'
      };
      return luxConfig;
    },

    title() {
      return this.description.title || '';
    }

  }),

  created() {
    registerStoreModule(this.$store, 'category/', category, true);
    registerStoreModule(this.$store, 'pageActions/', pageActions, true);

    if (process.client && !this.serverFetch) {
      const {
        params: {
          alias
        },
        query
      } = this.$route;
      const args = {
        alias,
        query,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.resetPagination();
      this.resetFilters();
      this.resetCategory();
      this.setDefaultFilterBy(extractCategoryFilterByFromQuery(query));
      this.setDefaultSortBy(extractCategorySortByFromQuery(query));
      this.setDefaultOrderBy(extractCategoryOrderByFromQuery(query));
      this.setPreviousPage(extractCategoryPreviousPageFromQuery(query));
      this.setNextPage(extractCategoryNextPageFromQuery(query));

      try {
        this.fetchCategory(args).then(() => {
          this.loadingProducts = false;
          this.createEbRecord();
          this.scrollBackToProduct(localStorage.getItem('currentProduct'));
          localStorage.removeItem('currentProduct');
        });
      } catch (error) {
        if (this.$sentry) {
          this.$sentry.captureException(error);
        }
      }
    }
  },

  mounted() {
    var _this = this;

    if (this.serverFetch) {
      this.fetchProducts();
    }

    this.unwatchCategoryQuery = this.$watch('categoryQuery',
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(function* (oldVal, newVal) {
        if (!shallowEqualObjects(oldVal, newVal)) {
          _this.loadingProducts = true;
          yield _this.handleWatcher(_this.fetchCategory, 1);

          _this.resetPagination();

          _this.loadingProducts = false;
        }
      });

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    this.unwatchNextPage = this.$watch('nextPage',
    /*#__PURE__*/
    _asyncToGenerator(function* () {
      const predicate = _this.nextPage === 1 && _this.previousPage === 1;

      if (!predicate) {
        _this.loadingNextPage = true;
        yield _this.handleWatcher(_this.appendProducts, _this.nextPage);
        _this.loadingNextPage = false;
      }
    }));
    this.unwatchPreviousPage = this.$watch('previousPage',
    /*#__PURE__*/
    _asyncToGenerator(function* () {
      const predicate = _this.nextPage === 1 && _this.previousPage === 1;

      if (!predicate) {
        _this.loadingPreviousPage = true;
        yield _this.handleWatcher(_this.prependProducts, _this.previousPage);
        _this.loadingPreviousPage = false;
      }
    }));
  },

  beforeDestroy() {
    this.unwatchCategoryQuery();
    this.unwatchNextPage();
    this.unwatchPreviousPage();
  },

  methods: _objectSpread({}, mapMutations({
    setDefaultFilterBy: 'pageActions/SET_DEFAULT_FILTERBY',
    setDefaultSortBy: 'pageActions/SET_DEFAULT_SORTBY',
    setDefaultOrderBy: 'pageActions/SET_DEFAULT_ORDERBY',
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE',
    resetPagination: 'pageActions/RESET_PAGINATION',
    resetFilters: 'pageActions/RESET_FILTERS',
    resetCategory: 'category/RESET_CATEGORY'
  }), mapActions({
    fetchCategory: 'category/fetchContent',
    appendProducts: 'category/appendProducts',
    prependProducts: 'category/prependProducts'
  }), {
    createEbRecord() {
      if (this.description) {
        const earlybirdsId = this.description.earlybirdsWidgets ? this.description.earlybirdsWidgets.id : null;
        window.ebRecoIds = [earlybirdsId];
      }
    },

    fetchProducts() {
      const args = {
        alias: this.$route.params.alias,
        query: _objectSpread({}, this.categoryQuery, {
          page: this.nextPage
        }),
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.fetchCategory(args).then(() => {
        this.loadingProducts = false;
        this.createEbRecord();
      });
    },

    handleWatcher(handler, page) {
      var _this2 = this;

      return _asyncToGenerator(function* () {
        const {
          params: {
            alias
          }
        } = _this2.$route;

        const query = _objectSpread({}, _this2.categoryQuery, {
          page
        });

        const profileId = _this2.$cookies.get('eb-profile') ? _this2.$cookies.get('eb-profile').split(':')[0] : '';

        try {
          yield handler({
            alias,
            query,
            profileId
          });

          _this2.$router.push({
            query: pickBy(query, e => !isNil(e))
          });

          _this2.$root.$emit('reset-tcvars');
        } catch (err) {
          if (_this2.$sentry) _this2.$sentry.captureException(err);
        }
      })();
    },

    scrollBackToProduct(arg) {
      if (arg) {
        const currentProduct = JSON.parse(arg);
        defer(() => {
          const product = document.getElementById(currentProduct);

          if (product) {
            window.scrollTo({
              top: product.offsetTop
            });
          }
        });
      }
    }

  }),

  head() {
    return {
      script: [this.speedcurveConfig]
    };
  }

};